import React, { Fragment, useState } from 'react';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import { getApi } from '../../api/endpoints.js';
import FiltersPartial from './FiltersPartial.js';
import UiAction from '../../components/UiAction.js';
import UI_ACTIONS from '../../data/UiActionConstants.js';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRemove, faTrash } from '@fortawesome/free-solid-svg-icons';
import DeleteModal from './DeleteModal.js';
import DissociateModal from './DissociateModal.js';
import { faEdit } from "@fortawesome/free-solid-svg-icons";

const Index = () => {
  const [filtersModel, setFiltersModel] = useState({});
  const defaultHeaderConfig = { disableSort: false };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDissociateModal, setShowDissociateModal] = useState(false);
  const [pincodeAttr, setPincodeAttr] = useState({});
  const navigate = useNavigate();

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'PIN Code',
      attr: 'pincode',
      disableSort: true
    },
    {
        ...defaultHeaderConfig,
        label: 'Area',
        attr: 'area',
        disableSort: true
    },
    {
        ...defaultHeaderConfig,
        label: 'Cluster',
        value: (row) => row.cluster?.name,
        disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'City',
      attr: 'city',
      disableSort: true
    },
    {
        ...defaultHeaderConfig,
        label: 'District',
        value: (row) => row.district?.name,
        disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'State',
      value: (row) => row.state?.name,
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Updated At',
      attr: 'updated_at',
      disableSort: true
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
        <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.delete_pin_code.name)}>
            <div style={{cursor: 'pointer'}} onClick={e => navigate(`/pincodes/${row.id}/edit`)}>
              <FontAwesomeIcon icon={faEdit} />
            </div>
          </UiAction>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.delete_pin_code.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onDeleteClick(row) }>
              <FontAwesomeIcon icon={faTrash}  className='text-danger'/>
            </div>
          </UiAction>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.dissociate_pin_code.name)}>
            <div style={{cursor: 'pointer'}} className='text-danger border rounded p-1 bg-danger-subtle' onClick={(e) => onDissociateclick(row) }>
            <FontAwesomeIcon icon={faRemove}/> Dissociate
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_pin_code.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add New Pincode(s)</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  const onNewClick = () => {
    navigate('/pincodes/new');
  }

  const onDeleteClick = (data) => {
    setPincodeAttr(data)
    setShowDeleteModal(true);
  }

  const onDissociateclick = (data) => {
    setPincodeAttr(data)
    setShowDissociateModal(true);
  }

  return <>
    <Fragment>
      <DeleteModal pincodeAttr={pincodeAttr} showDeleteModal={showDeleteModal} setShowDeleteModal={setShowDeleteModal}/>
    </Fragment>
    <Fragment>
      <DissociateModal pincodeAttr={pincodeAttr} showDissociateModal={showDissociateModal} setShowDissociateModal={setShowDissociateModal}/>
    </Fragment>
    <ListingPageComponent
      key={PAGES.PincodesListingPage.name}
      uiPage={uiManager.getUiPage(PAGES.PincodesListingPage.name)}
      breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'PIN Codes List' }]}
      listingMutation={getApi('pincodes')}
      recordsKey="pincodes"
      className="pincodes-listing-page"
      contentHeading="PIN Codes List - Results"
      headers={headers}
      searchBy={['id', 'PIN Code', 'City']}
      filtersModel={filtersModel}
      filters={
        <FiltersPartial
          filtersModel={filtersModel}
          setFiltersModel={setFiltersModel}
        />
      }
      tableHeaderActionsComponent={tableHeaderActionsComponent()}
    />
  </>
}

export default Index;
